export default {
  DESKTOP_CONTENT_WIDTH: 1200,
  md: 768,
  CARD_WIDTH: 300,
  medium: '768px',
}